import { z } from 'zod'

const LocationQtySchema = z.object({
  location: z.string(),
  qty: z.number(),
})

const ItemSchema = z.object({
  id: z.number(),
  seq: z.number(),
  itemId: z.number(),
  lotNo: z.string(),
  unit: z.string(),
  qty: z.number(),
  locations: z.array(LocationQtySchema),
  isLocationFulfilled: z.boolean(),
})

export const Inv2010GetResultSchema = z.object({
  number: z.string(),
  date: z.string(),
  refNo: z.string(),
  refDate: z.coerce.date().nullable(),
  remark: z.string().nullish(),
  items: z.array(ItemSchema),
  isFulfilled: z.boolean().nullable(),
  status: z.number(),
})

export type Inv2010GetResultModel = z.input<typeof Inv2010GetResultSchema>
